import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { rentalDateLongFormat } from '../../../utils/variables';

function ReservationTime({ rental }) {
  const { t } = useTranslation(['booking', 'common', 'search']);

  return (
    <div className="section flex-row">
      <div>
        <div className="title">{t('booking:start')}</div>
        <div className="date">
          {moment(rental.reservation_start_time).format(rentalDateLongFormat)}
        </div>
      </div>
      <div>
        <div className="title">{t('booking:end')}</div>
        <div className="date">
          {moment(rental.reservation_end_time).format(rentalDateLongFormat)}
        </div>
      </div>
    </div>
  );
}

export default ReservationTime;
